const UPSERT_EVENT = 'risman:recent-activity-upsert';
const RELOAD_EVENT = 'risman:recent-activity-reload';
const REMOVE_EVENT = 'risman:recent-activity-remove';

export const notifyRecentActivityUpsert = (item) => {
  if (!item?.id || !item?.type || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(UPSERT_EVENT, { detail: item }));
};

export const notifyRecentActivityReload = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(RELOAD_EVENT));
};

export const notifyRecentActivityRemoved = (item) => {
  if (typeof window === 'undefined') return;
  if (item?.all) {
    window.dispatchEvent(new CustomEvent(REMOVE_EVENT, { detail: item }));
    return;
  }
  if (!item?.id || !item?.type) return;
  window.dispatchEvent(new CustomEvent(REMOVE_EVENT, { detail: item }));
};

export const subscribeRecentActivity = ({ onUpsert, onReload, onRemove } = {}) => {
  if (typeof window === 'undefined') return () => {};

  const handleUpsert = (event) => onUpsert?.(event.detail);
  const handleReload = () => onReload?.();
  const handleRemove = (event) => onRemove?.(event.detail);

  if (onUpsert) window.addEventListener(UPSERT_EVENT, handleUpsert);
  if (onReload) window.addEventListener(RELOAD_EVENT, handleReload);
  if (onRemove) window.addEventListener(REMOVE_EVENT, handleRemove);

  return () => {
    if (onUpsert) window.removeEventListener(UPSERT_EVENT, handleUpsert);
    if (onReload) window.removeEventListener(RELOAD_EVENT, handleReload);
    if (onRemove) window.removeEventListener(REMOVE_EVENT, handleRemove);
  };
};
